import React from 'react';
import { Grid, Typography, MenuItem, Box, CircularProgress, FormControl, InputLabel, Select } from '@mui/material';
import { useClient } from '../../../../reactQuery/client';

const ClientSelector = ({ selectedClient, setSelectedClient }) => {
  // Use React Query to fetch clients
  const { 
    responseData: clientsData, 
    isLoading: isClientsLoading, 
    error: clientsError 
  } = useClient({ page: 1, pageSize: 100, pagination: false });
  
  // Format clients data for dropdown
  const clients = Array.isArray(clientsData) ? clientsData.map(client => ({
    value: client.client_id,
    label: client.name || client.company_name
  })) : [];

  return (
    <Grid item xs={12}>
      <FormControl fullWidth variant="outlined">
        <InputLabel shrink htmlFor="client-select">
          Client
        </InputLabel>
        <Select
          id="client-select"
          value={selectedClient || ""}
          onChange={(e) => setSelectedClient(e.target.value)}
          disabled={isClientsLoading}
          displayEmpty
          label="Client"
        >
          <MenuItem value="" disabled>
            <em>{isClientsLoading ? "Loading clients..." : "Select client"}</em>
          </MenuItem>
          {isClientsLoading ? (
            <MenuItem disabled>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <CircularProgress size={20} sx={{ mr: 1 }} /> Loading...
              </Box>
            </MenuItem>
          ) : clients.length > 0 ? (
            clients.map((client) => (
              <MenuItem key={client.value} value={client.value}>
                {client.label}
              </MenuItem>
            ))
          ) : (
            <MenuItem disabled>No clients found</MenuItem>
          )}
        </Select>
      </FormControl>
      {clientsError && (
        <Typography color="error" variant="caption">
          Error loading clients. Please try again.
        </Typography>
      )}
    </Grid>
  );
};

export default ClientSelector;
